import React, { ReactElement } from 'react';

import ToolbarPopupTool from '../../../ToolbarPopupTool';
import ElementLabelsToolbarPopup from './ElementLabelsToolbarPopup';

import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import { useSelector } from 'react-redux';
import { canShowLabelsToolSelector } from '../labelToolSelectors';

type Props = {
    selectedElements: Immutable.List<ImMNElement>;
};

const LabelTool = (props: Props): ReactElement | null => {
    const canShowLabelsTool = useSelector(canShowLabelsToolSelector);

    if (!canShowLabelsTool) return null;

    return (
        <ToolbarPopupTool
            {...props}
            popupId={PopupIds.LABELS_TOOL}
            toolName={'Label'}
            buttonSelector=".LabelTool .icon"
            PopupComponent={ElementLabelsToolbarPopup}
        />
    );
};

export default LabelTool;
